import { useLingui } from '@lingui/react';
import { CheckCircleIcon } from '@wkda/icons';
import cx from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BenefitsList(_ref) {
  let {
    className,
    classNameRow,
    classNameRowText,
    benefitsTranslations
  } = _ref;
  const {
    i18n: _i18n
  } = useLingui();
  return /*#__PURE__*/_jsx("ul", {
    className: cx('banner-return-customer__list', className),
    children: benefitsTranslations.map(translation => /*#__PURE__*/_jsxs("li", {
      className: cx('banner-return-customer__list-item', classNameRow),
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(CheckCircleIcon, {
          className: "banner-return-customer__list-icon"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: cx('banner-return-customer__list-item-text', classNameRowText),
        children: _i18n._(translation)
      })]
    }, translation))
  });
}